var FLOSSLO_QUICK_ADD_TOAST_DELAY = 3000;
var flossloQuickAddToastTimer;

function getFlossloQuickAddToast() {
  let toast = document.querySelector("[data-flosslo-quick-add-toast]");

  if (toast) return toast;

  toast = document.createElement("div");
  toast.className = "flosslo-quick-add-toast";
  toast.setAttribute("data-flosslo-quick-add-toast", "");
  toast.setAttribute("role", "status");
  toast.setAttribute("aria-live", "polite");
  toast.setAttribute("aria-atomic", "true");
  toast.innerHTML =
    '<span class="flosslo-quick-add-toast__icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M20 6 9 17l-5-5"/></svg></span><span class="flosslo-quick-add-toast__copy"><span class="flosslo-quick-add-toast__title">Added to cart</span><span class="flosslo-quick-add-toast__detail">Item added to cart</span></span>';
  document.body.appendChild(toast);

  return toast;
}

function showFlossloQuickAddToast(productTitle, quantity) {
  const toast = getFlossloQuickAddToast();
  const detail = toast.querySelector(".flosslo-quick-add-toast__detail");
  const cleanTitle = productTitle ? productTitle.replace(/\s+/g, " ").trim() : "";

  if (detail) {
    detail.textContent = cleanTitle ? `${cleanTitle} x ${quantity}` : "Item added to cart";
  }

  window.clearTimeout(flossloQuickAddToastTimer);
  toast.classList.remove("is-visible");
  window.requestAnimationFrame(() => {
    toast.classList.add("is-visible");
  });
  flossloQuickAddToastTimer = window.setTimeout(() => {
    toast.classList.remove("is-visible");
  }, FLOSSLO_QUICK_ADD_TOAST_DELAY);
}

function defineQuickAddBulk() {
  if (customElements.get("quick-add-bulk")) return;

  if (typeof BulkAdd === "undefined") {
    window.addEventListener("DOMContentLoaded", defineQuickAddBulk, {
      once: true,
    });
    return;
  }

  customElements.define(
    "quick-add-bulk",
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector("quantity-input");

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener("change", debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;

        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get("page") || "");
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          event = event || {};
          const variantId = parseInt(this.dataset.index, 10);

          if (event.source === "quick-add") return;

          if (
            event.variantId &&
            parseInt(event.variantId, 10) !== variantId
          ) {
            return;
          }

          if (Array.isArray(event.cartData?.items)) {
            this.syncVariantQuantity(
              this.dataset.index,
              this.getCartQuantityForVariant(event.cartData, variantId)
            );
            return;
          }

          if (
            event.cartData?.variant_id &&
            event.cartData.variant_id !== variantId
          ) {
            return;
          }

          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      getInput() {
        return this.querySelector("quantity-input input");
      }

      selectProgressBar() {
        return this.querySelector(".progress-bar-container");
      }

      listenForActiveInput() {
        const input = this.getInput();
        if (!this.classList.contains("hidden") && input) {
          input.addEventListener("focusin", (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        const input = this.getInput();
        if (!input) return;

        input.addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
            input.blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          "keypress",
          () => {
            event.target.setCustomValidity("");
          },
          { once: true }
        );
      }

      getAddedItems(items) {
        return Object.keys(items)
          .map((id) => {
            const nextQuantity = parseInt(items[id], 10);
            const input = this.querySelector(`#Quantity-${id}`);
            const previousQuantity = parseInt(
              input?.getAttribute("value") || input?.dataset.cartQuantity || "0",
              10
            );

            return {
              id,
              quantity: nextQuantity - previousQuantity,
            };
          })
          .filter((item) => item.quantity > 0);
      }

      getPreviousQuantities(items) {
        return Object.keys(items).reduce((quantities, id) => {
          const input =
            this.querySelector(`quantity-input input[data-index="${id}"]`) ||
            this.querySelector(`#Quantity-${id}`);
          const previousQuantity = parseInt(
            input?.dataset.cartQuantity || input?.getAttribute("value") || "0",
            10
          );

          quantities[id] = Number.isNaN(previousQuantity) ? 0 : previousQuantity;
          return quantities;
        }, {});
      }

      getCartQuantityForVariant(cartData, id) {
        if (!Array.isArray(cartData?.items)) return null;

        return cartData.items.reduce((quantity, item) => {
          return item.id === parseInt(id, 10) ? quantity + item.quantity : quantity;
        }, 0);
      }

      syncQuantityInput(input, quantity) {
        const normalizedQuantity = Number.isFinite(quantity) ? quantity : 0;

        input.value = normalizedQuantity;
        input.setAttribute("value", normalizedQuantity);
        input.dataset.cartQuantity = normalizedQuantity;

        const quantityInput = input.closest("quantity-input");
        if (quantityInput && typeof quantityInput.validateQtyRules === "function") {
          quantityInput.validateQtyRules();
        }
      }

      syncVariantQuantity(id, quantity) {
        document
          .querySelectorAll(
            `quantity-input input[data-quantity-variant-id="${id}"], quantity-input input[data-index="${id}"]`
          )
          .forEach((input) => {
            this.syncQuantityInput(input, quantity);
          });
      }

      syncRequestedQuantities(cartData, ids, fallbackQuantities) {
        ids.forEach((id) => {
          const cartQuantity = this.getCartQuantityForVariant(cartData, id);
          const fallbackQuantity = fallbackQuantities[id];
          const quantity = cartQuantity === null ? fallbackQuantity : cartQuantity;

          this.syncVariantQuantity(id, quantity);
        });
      }

      getAddedQuantityFromCart(cartData, ids, previousQuantities) {
        if (!Array.isArray(cartData?.items)) return 0;

        return ids.reduce((quantity, id) => {
          const cartQuantity = this.getCartQuantityForVariant(cartData, id);
          const previousQuantity = previousQuantities[id] || 0;

          return cartQuantity > previousQuantity
            ? quantity + cartQuantity - previousQuantity
            : quantity;
        }, 0);
      }

      getProductTitle() {
        const card = this.closest(".product-card-wrapper") || this.closest(".card-wrapper") || this;
        const heading = card.querySelector(".card__heading a, .card__heading");

        return heading?.textContent || "";
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          const collection = this.closest(".collection");
          const sectionId = collection?.dataset.id;

          if (!sectionId) {
            resolve();
            return;
          }

          fetch(`${this.getSectionsUrl()}?section_id=${sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const sourceQty = new DOMParser()
                .parseFromString(responseText, "text/html")
                .querySelector(`#quick-add-bulk-${this.dataset.id}-${sectionId}`);

              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }

              resolve();
            })
            .catch((error) => {
              console.error(error);
              reject(error);
            });
        });
      }

      updateMultipleQty(items) {
        const progressBar = this.selectProgressBar();
        progressBar?.classList.remove("hidden");

        const ids = Object.keys(items);
        const previousQuantities = this.getPreviousQuantities(items);
        const productTitle = this.getProductTitle();
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
          .then((response) => {
            return response.text().then((state) => {
              if (!response.ok) {
                throw new Error(state);
              }

              return state;
            });
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            if (!Array.isArray(parsedState.items) || parsedState.errors || parsedState.message) {
              throw new Error(parsedState.errors || parsedState.message || "Cart update failed");
            }

            this.renderSections(parsedState, ids);
            this.syncRequestedQuantities(parsedState, ids, previousQuantities);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "quick-add",
              cartData: parsedState,
            });
            const addedQuantity = this.getAddedQuantityFromCart(
              parsedState,
              ids,
              previousQuantities
            );
            if (addedQuantity > 0 && !parsedState.errors && !parsedState.message) {
              showFlossloQuickAddToast(productTitle, addedQuantity);
            }
          })
          .catch(() => {
            this.syncRequestedQuantities(null, ids, previousQuantities);
          })
          .finally(() => {
            progressBar?.classList.add("hidden");
            this.requestStarted = false;
          });
      }

      getSectionsToRender() {
        const bulkSectionId = this.closest(".collection-quick-add-bulk")?.dataset.id;
        const sections = [];

        if (bulkSectionId) {
          sections.push({
            id: `quick-add-bulk-${this.dataset.id}-${bulkSectionId}`,
            section: bulkSectionId,
            selector: `#quick-add-bulk-${this.dataset.id}-${bulkSectionId}`,
          });
        }

        sections.push(
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          },
          {
            id: "CartDrawer",
            selector: "#CartDrawer",
            section: "cart-drawer",
          }
        );

        return sections;
      }

      renderSections(parsedState, ids) {
        if (this.queue.filter((element) => ids.includes(element.id)).length !== 0) return;

        this.getSectionsToRender().forEach((section) => {
          if (!section.section || !parsedState.sections?.[section.section]) return;

          const sectionElement = document.getElementById(section.id);

          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains("drawer")
          ) {
            if (parsedState.items.length > 0) {
              sectionElement.parentElement.classList.remove("is-empty");
            } else {
              sectionElement.parentElement.classList.add("is-empty");
            }

            setTimeout(() => {
              const cartDrawerOverlay = document.querySelector("#CartDrawer-Overlay");
              if (cartDrawerOverlay && this.cart) {
                cartDrawerOverlay.addEventListener("click", this.cart.close.bind(this.cart));
              }
            });
          }

          const sourceElement = new DOMParser()
            .parseFromString(parsedState.sections[section.section], "text/html")
            .querySelector(section.selector);

          if (!sourceElement) return;

          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;

          if (elementToReplace) {
            elementToReplace.innerHTML = sourceElement.innerHTML;
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`)?.select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}

defineQuickAddBulk();
